export default __webpack_public_path__ + "static/media/civ.0eac1d86.svg";